module.exports = __webpack_public_path__ + "static/banner-fb67ebbeb80c5d5da713fe4a4be04c01.png";